const STORAGE_KEY = 'sticky_notes_board_v1';

// Save notes to localStorage
export function saveNotes(notes) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(notes));
}

// Load notes from localStorage
export function loadNotes() {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : [];
}

// Generate a unique ID for each note
export function uid() {
  return Math.random().toString(36).slice(2, 9);
}
